import React, { useContext } from 'react';

import moment from 'moment/moment';

import { ProjectStage, ProjectStageEnum, translateProjectStage } from '../../../../api-client';
import { formatDate, formatTime } from '../../../../formatters';
import { CheckIcon } from '../../../common';
import { DetailedProjectContext } from '../DetailedProjectContext/DetailedProjectContext';
import DetailedProjectNavigation from '../DetailedProjectNavigation';
import { useWindowWidth } from '../hooks';
import ProjectDropdown from '../ProjectDropdown';

import './ProjectStages.scoped.scss';

const ProjectStages = () => {
  const project = useContext(DetailedProjectContext).project;
  const isMobile = useWindowWidth();

  const stageName = (stage: ProjectStage): string => {
    if (Object.keys(ProjectStageEnum).includes(stage.name)) {
      return translateProjectStage(stage.name as ProjectStageEnum);
    }
    return stage.name;
  };

  const renderStages = () => {
    if (project.stages.length === 0) {
      return <div className="project-stages__placeholder">События не указаны</div>;
    }
    const renderedStages = project.stages.map((stage) => {
      const date = moment(stage.createdAt).toDate();
      return (
        <li className="project-stage__element" key={stage.uuid}>
          <div className="project-stage">
            <div className="project-stage__left">
              <div className="project-stage__icon">
                <CheckIcon preset="success" title="Событие" />
              </div>
              <div>
                <div className="project-stage__name">{stageName(stage)}</div>
                {stage.content !== null && (
                  <div className="project-stage__content">{stage.content}</div>
                )}
              </div>
            </div>
            <div>
              <div className="project-stage__date">{formatDate(date)}</div>
              <div className="project-stage__date">{formatTime(date)}</div>
            </div>
          </div>
        </li>
      );
    });
    return <ul className="project-stages__list">{renderedStages}</ul>;
  };

  return (
    <div className="project-stages-container">
      {isMobile ? (
        <ProjectDropdown header="События">{renderStages()}</ProjectDropdown>
      ) : (
        <>
          <div className="detailed-project__header">
            <DetailedProjectNavigation />
          </div>
          <div className="detailed-project__content">{renderStages()}</div>
        </>
      )}
    </div>
  );
};

export default ProjectStages;
